import PropTypes from 'prop-types';
import { BsXLg } from 'react-icons/bs';

import Button from '#globalComponents/Button/Button';
import IconButton from '#globalComponents/IconButton/IconButton';

const TONES = {
	accent: { surface: 'bg-accent text-text', button: 'solid', close: 'text-text hover:bg-text/10 hover:text-text' },
	primary: {
		surface: 'bg-primary-500 text-white',
		button: 'white',
		close: 'text-white hover:bg-white/15 hover:text-white',
	},
	caution: {
		surface: 'bg-caution-700 text-white',
		button: 'white',
		close: 'text-white hover:bg-white/15 hover:text-white',
	},
	warning: {
		surface: 'bg-warning-700 text-white',
		button: 'white',
		close: 'text-white hover:bg-white/15 hover:text-white',
	},
};

const AppBanner = ({ tone, icon: Icon, children, action, onDismiss }) => {
	const { surface, button, close } = TONES[tone];

	return (
		<div
			className={`relative flex min-h-12 items-center justify-center gap-3 py-2 text-sm ${surface} ${
				onDismiss ? 'px-12' : 'px-4'
			}`}
		>
			{Icon && <Icon className="hidden h-4 w-4 flex-shrink-0 sm:block" />}

			<span className="text-center">{children}</span>

			{action && (
				<Button
					variant={button}
					size="sm"
					className="flex-shrink-0"
					onClick={action.onClick}
					loading={action.loading}
				>
					{action.label}
				</Button>
			)}

			{onDismiss && (
				<IconButton
					icon={BsXLg}
					label="Banner schließen"
					onClick={onDismiss}
					className={`absolute right-2 top-1/2 -translate-y-1/2 ${close}`}
				/>
			)}
		</div>
	);
};

AppBanner.propTypes = {
	tone: PropTypes.oneOf(Object.keys(TONES)).isRequired,
	icon: PropTypes.elementType,
	children: PropTypes.node.isRequired,
	action: PropTypes.shape({
		label: PropTypes.string.isRequired,
		onClick: PropTypes.func.isRequired,
		loading: PropTypes.bool,
	}),
	onDismiss: PropTypes.func,
};

export default AppBanner;
